import { globalConstants } from "../constants";
import { postRequest, getRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

//-------get all approved center list
const getAllApprovedCentersList = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/all/approved`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getAllApprovedCentersListBySpotId = (data,spotId) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/spot/${spotId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
//Get center profile by id
const getCenterProfileById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Center/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get View center profile by id
const getViewCenterProfileById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Center/view/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//-------get all center instructors list
const getAllCenterInstructors = (data, centerId) => {
  return postRequest(
    `/${globalConstants.VERSION}/Instructor/center/view/${centerId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//-------get all center activities
const getAllCenterActivities = (data, centerId) => {
  return postRequest(
    `/${globalConstants.VERSION}/CenterActivity/center/view/${centerId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//-------export center listing services
export const centerListingService = {
  getAllApprovedCentersList,
  getCenterProfileById,
  getViewCenterProfileById,
  getAllCenterInstructors,
  getAllCenterActivities,
  getAllApprovedCentersListBySpotId
};
